import { SVGProps } from 'react';

const Bubbles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.2 14.8a2 2 0 0 1 2 2M22 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-9 8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-3-12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    />
  </svg>
);
export default Bubbles;
